export const PageSection = (props: any) => {

  const {
    marginTop,
    title,
    children
  } = props;

  return (
    <div className="page-section" style={{ marginTop: marginTop || '0' }}>
      <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
        {title}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5rem', flexWrap: 'wrap' }}>
        {children}
      </div>
    </div>
  )
}